import React, { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import { withAuthConsumer } from "../authcontext/AuthConsumer";
import LeftNav from "../components/LeftNav";
import Err403 from "../containers/Err403";
import "@reach/skip-nav/styles.css";

const SignedInHOC = (WrappedComponent) => {
  const SignedInHOC = (props) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const { t, i18n } = useTranslation();

    // Create history object for backwards compatibility with class components
    const history = {
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      location
    };

    useEffect(() => {
      const handleResize = () => {
        setScreenWidth(window.innerWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const groupsAccessRoutes = (group, pathname) => {
      let canAccessRoutes = false;

      const groupsRoutes = {
        admin: [
          "tableau-de-bord",
          "produits",
          "produits-deposer",
          "produits-details",
          "offres-groupes",
          "offres-groupes-details",
          "demandes",
          "demandes-details",
          "historique-achats-produits",
          "historique-achats-produits-details",
          "conditions-d-acces",
          "parametres",
          "aide",
          "faq"
        ],
        approver: [
          "tableau-de-bord",
          "bons-de-commande",
          "commandes",
          "commande-details",
          "historique-achats-representants",
          "historique-achats-representants-details",
          "conditions-d-acces",
          "parametres",
          "aide",
          "faq"
        ]
      };

      switch (group) {
        case "superadmin":
          canAccessRoutes = true;
          break;

        case "admin":
          canAccessRoutes = groupsRoutes["admin"].includes(pathname);
          break;

        case "approver":
          canAccessRoutes = groupsRoutes["approver"].includes(pathname);
          break;

        default:
          canAccessRoutes = false;
      }

      return canAccessRoutes;
    };

    const skipNav = () => {
      document.getElementById("skipMenu").focus();
    };

    const isAuthenticated = window.localStorage.getItem("isAuthenticated");
    const userGroup = window.localStorage.getItem("userGroup");
    let path = location.pathname.split("/");
    const userCanAccessRoutes = groupsAccessRoutes(userGroup, path[1]);

    if (!isAuthenticated) {
      return <Navigate to="/connexion" replace />;
    }

    return (
      <>
        <button className="skipMain" onClick={skipNav}>
          {t("Passer au contenu")}
        </button>
        <main className="flex mainContent">
          {userCanAccessRoutes ? (
            <>
              {700 < screenWidth ? (
                <>
                  <div className="p-2" style={{ width: "19rem" }}>
                    <LeftNav {...props} t={t} i18n={i18n} history={history} location={location} match={{ params }} />
                  </div>
                  <div
                    className="w-4/5 xl:overflow-visible lg:overflow-visible overflow-hidden xl:p-8 xl:pb-0"
                    style={{ borderLeft: "1px solid #EAEBEC" }}
                  >
                    <div id="skipMenu" tabIndex="-1"></div>
                    <WrappedComponent {...props} t={t} i18n={i18n} history={history} location={location} match={{ params }} />
                  </div>
                </>
              ) : (
                <div className="p-4 w-full">
                  <div className="mb-2">
                    <LeftNav {...props} t={t} i18n={i18n} history={history} location={location} match={{ params }} />
                  </div>
                  <div className="w-full">
                    <WrappedComponent {...props} t={t} i18n={i18n} history={history} location={location} match={{ params }} />
                  </div>
                </div>
              )}
            </>
          ) : (
            <Err403 />
          )}
        </main>
        <Footer />
      </>
    );
  };

  return withAuthConsumer(SignedInHOC);
};

export default SignedInHOC;
